module.exports = __webpack_public_path__ + "img/tech8.e1f42965.jpg";